export default __webpack_public_path__ + "static/media/hu.8da0721d.jpg";